export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_INICIO = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_INICIO';
export const dataInicio = (dataInicio) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_INICIO,
  payload: {
    dataInicio,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_FIM = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_FIM';
export const dataFim = (dataFim) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_FIM,
  payload: {
    dataFim,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPOPERIODO = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPOPERIODO';
export const tipoPeriodo = (tipoPeriodo) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPOPERIODO,
  payload: {
    tipoPeriodo,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_FILTRO_VALUE = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_LISTA = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_LISTA';
export const lista = (lista) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_LISTA,
  payload: {
    lista,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPO = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPO';
export const tipo = (tipo) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPO,
  payload: {
    tipo,
  },
});
export const ARQUIVAMENTO_RELATORIOS_ATUALIZAR_IMPRIMIR = 'ARQUIVAMENTO_RELATORIOS_ATUALIZAR_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: ARQUIVAMENTO_RELATORIOS_ATUALIZAR_IMPRIMIR,
  payload: {
    imprimir,
  },
});




// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Relatorios/store/relatorios.action.js